const DEFAULT_LOCALE = 'en-US'

export function formatAmount(value, digits = 2, locale = DEFAULT_LOCALE) {
  const amount = Number(value)
  const safeAmount = Number.isFinite(amount) ? amount : 0

  return safeAmount.toLocaleString(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })
}

export function formatCurrency(value, currencyLabel = 'RM') {
  return `${currencyLabel} ${formatAmount(value, 2)}`
}
